<template>
  <div class="w-100 d-flex flex-column h-100">
    <base-tool-bar
      title="Informations"
      subtitle="Informations générales et état civil du collaborateur"
    ></base-tool-bar>
    <base-form
      class="mr-md-3"
      @click="updateCollaborateur"
      :loading="loading"
      shadow
    >
      <base-form-group title="Etat civil" dense icon="user">
        <base-form-row row>
          <base-input
            v-model="collaborateur_nom"
            inputText="Nom d'usage"
            :errors="feedback.collaborateur_nom"
          ></base-input>
          <base-input
            v-model="collaborateur_matricule"
            inputText="Matricule"
            :errors="feedback.collaborateur_matricule"
          ></base-input>
        </base-form-row>
        <base-form-row row>
          <base-input
            v-model="collaborateur_nom_naissance"
            inputText="Nom de naissance"
            :errors="feedback.collaborateur_nom_naissance"
          ></base-input>
          <base-input
            v-model="collaborateur_prenom"
            inputText="Prénom"
            :errors="feedback.collaborateur_prenom"
          ></base-input>
        </base-form-row>
        <base-form-row row>
          <base-inputDatePicker
            v-model="collaborateur_date_naissance"
            inputText="Date de naissance"
            :errors="feedback.collaborateur_date_naissance"
          ></base-inputDatePicker>
          <base-input
            v-model="collaborateur_adresse_naissance"
            inputText="Ville de naissance"
            :errors="feedback.collaborateur_adresse_naissance"
          ></base-input>
        </base-form-row>
        <base-form-row row>
          <base-select
            inputText="Sexe"
            v-model.number="collaborateur_sexe_id"
            :options="data.sexes"
            :errors="feedback.collaborateur_sexe_id"
          ></base-select>
          <base-select
            inputText="Nationalité"
            v-model.number="collaborateur_nationalite_id"
            :options="data.nationalites"
            :errors="feedback.collaborateur_nationalite_id"
          ></base-select>
        </base-form-row>
        <base-form-row>
          <base-input
            v-model="collaborateur_rinpp"
            inputText="N° sécurité sociale (RINPP)"
            :errors="feedback.collaborateur_rinpp"
          ></base-input>
        </base-form-row>
        <base-form-row>
          <base-select
            inputText="Formation initiale"
            v-model.number="collaborateur_niveau_formation_id"
            :options="data.niveauxFormation"
            :errors="feedback.collaborateur_niveau_formation_id"
          ></base-select>
        </base-form-row>
        <base-form-row row>
          <base-select
            inputText="Situation de famille"
            v-model.number="collaborateur_situation_famille_id"
            :options="data.situationsFamille"
            :errors="feedback.collaborateur_situation_famille_id"
          ></base-select>
          <base-input-number
            v-model="collaborateur_enfants"
            inputText="Nombre d'enfants à charge"
            :errors="feedback.collaborateur_enfants"
          ></base-input-number>
        </base-form-row>
      </base-form-group>

      <!-- Nouvelle section pour les enfants -->
      <base-form-group title="Enfants" dense icon="child">
        <div class="mb-3 text-right">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="ajouterEnfant"
          >
            + Ajouter un enfant
          </button>
        </div>

        <div
          v-if="
            collaborateur_enfants_details &&
              collaborateur_enfants_details.length > 0
          "
        >
          <div
            v-for="(enfant, index) in collaborateur_enfants_details"
            :key="index"
            class="border p-3 mb-3 rounded bg-light"
          >
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Enfant #{{ index + 1 }}</h6>
              <button
                type="button"
                class="btn btn-sm btn-danger"
                @click="supprimerEnfant(index)"
              >
                Supprimer
              </button>
            </div>

            <base-form-row row>
              <base-input
                v-model="collaborateur_enfants_details[index].nom"
                inputText="Nom"
                :errors="getEnfantFieldError(index, 'nom')"
              ></base-input>
              <base-input
                v-model="collaborateur_enfants_details[index].prenom"
                inputText="Prénom"
                :errors="getEnfantFieldError(index, 'prenom')"
              ></base-input>
            </base-form-row>

            <base-form-row>
              <base-inputDatePicker
                v-model="collaborateur_enfants_details[index].date_naissance"
                inputText="Date de naissance"
                :errors="getEnfantFieldError(index, 'date_naissance')"
              ></base-inputDatePicker>
            </base-form-row>
          </div>
        </div>

        <div v-else class="text-center p-4 bg-light border rounded">
          <i class="fas fa-child fa-2x mb-2 text-muted"></i>
          <p class="text-muted mb-0">Aucun enfant enregistré</p>
        </div>
      </base-form-group>
    </base-form>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapActions, mapGetters } from "vuex";
import { errHandler } from "@/helpers.js";
import BaseInput from "@/components/bases/Input.vue";
import BaseInputNumber from "@/components/bases/InputNumber.vue";
import BaseSelect from "@/components/bases/Select.vue";
import BaseInputDatePicker from "@/components/bases/InputDatePicker.vue";
import BaseForm from "@/components/bases/Form.vue";
import BaseFormGroup from "@/components/bases/FormGroup.vue";
import BaseFormRow from "@/components/bases/FormRow.vue";
import BaseToolBar from "@/components/bases/ToolBar.vue";

export default {
  components: {
    BaseInput,
    BaseInputNumber,
    BaseSelect,
    BaseInputDatePicker,
    BaseForm,
    BaseFormGroup,
    BaseFormRow,
    BaseToolBar
  },
  data() {
    return {
      feedback: {},
      loading: false,
      statut: null
    };
  },
  methods: {
    ...mapActions({
      _updateCollaborateur: "collaborateurs/updateCollaborateur"
    }),
    updateCollaborateur: function() {
      this.feedback = {};
      this.loading = true;

      this.collaborateur_enfants = this.collaborateur_enfants_details.length;

      this._updateCollaborateur()
        .catch(error => (this.feedback = errHandler(error)))
        .finally(() => (this.loading = false));
    },
    ajouterEnfant() {
      // S'assurer que le tableau existe
      if (!this.collaborateur_enfants_details) {
        this.$set(this.collaborateur, "collaborateur_enfants_details", []);
      }

      // Ajouter un nouvel enfant
      this.collaborateur_enfants_details.push({
        nom: "",
        prenom: "",
        date_naissance: null
      });

      // Mettre à jour le compteur
      this.collaborateur_enfants = this.collaborateur_enfants_details.length;
    },

    supprimerEnfant(index) {
      // Supprimer un enfant du tableau
      this.collaborateur_enfants_details.splice(index, 1);

      // Mettre à jour le compteur
      this.collaborateur_enfants = this.collaborateur_enfants_details.length;
    },

    getEnfantFieldError(index, field) {
      // Récupérer les erreurs pour un champ spécifique d'un enfant
      if (!this.feedback.collaborateur_enfants_details) return null;
      if (!this.feedback.collaborateur_enfants_details[index]) return null;
      return this.feedback.collaborateur_enfants_details[index][field];
    }
  },
  computed: {
    ...mapFields("collaborateurs", [
      "collaborateur.collaborateur_matricule",
      "collaborateur.collaborateur_nom",
      "collaborateur.collaborateur_nom_naissance",
      "collaborateur.collaborateur_prenom",
      "collaborateur.collaborateur_date_naissance",
      "collaborateur.collaborateur_rinpp",
      "collaborateur.collaborateur_sexe_id",
      "collaborateur.collaborateur_nationalite_id",
      "collaborateur.collaborateur_adresse_naissance",
      "collaborateur.collaborateur_situation_famille_id",
      "collaborateur.collaborateur_enfants",
      "collaborateur.collaborateur_niveau_formation_id",
      "collaborateur.collaborateur_hierarchique_id",
      "collaborateur.collaborateur_enfants_details"
    ]),
    ...mapGetters({
      data: "collaborateurs/data"
    })
  },
  created() {
    // Initialiser le tableau des enfants s'il n'existe pas
    if (!this.collaborateur_enfants_details) {
      this.$set(this.collaborateur, "collaborateur_enfants_details", []);
    }

    // Si le nombre d'enfants est défini mais que les détails ne sont pas renseignés,
    // créer des entrées vides pour chaque enfant
    if (
      this.collaborateur_enfants > 0 &&
      this.collaborateur_enfants_details.length === 0
    ) {
      for (let i = 0; i < this.collaborateur_enfants; i++) {
        this.collaborateur_enfants_details.push({
          nom: "",
          prenom: "",
          date_naissance: null
        });
      }
    }
  }
};
</script>
<style lang="css">
/* Styles pour l'animation lors de l'ajout/suppression d'enfants */
.enfant-item-enter-active,
.enfant-item-leave-active {
  transition: all 0.3s ease;
}
.enfant-item-enter,
.enfant-item-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
